{
  "exportGeoJson": {
    "exportLayersInfo": "Selected layers are being exported, we'll let you know when it is ready"
  },
  "importGeoJson": {
    "invalidGeoJson": {
      "title": "Invalid file type",
      "message": "The file you have uploaded is invalid. Please upload a valid GeoJSON, JSON, GPX or KML/KMZ file."
    },
    "somethingWentWrong": {
      "title": "Something went wrong",
      "message": "The file type you have uploaded is invalid. Please upload a valid GeoJSON, JSON, GPX or KML/KMZ file."
    },
    "fileTooLarge": {
      "title": "File size too large",
      "message": "The file you are trying to upload is too large. Maximum file size is {{ size }}."
    },
    "invalidGeometry": {
      "title": "Invalid geometry",
      "message": "The layer type you are trying to upload has invalid geometry."
    },
    "invalidLayerType": {
      "title": "Incompatible layer type",
      "message": "You are trying to upload a {{ importType }} layer to an {{ layerType }} layer."
    },
    "invalidCoordinateSystem": {
      "title": "Coordinate system not supported",
      "message": "Coordinate system is not supported please use {{ coordinateSystem }}"
    },
    "reuploadGeoJson": "Supported file extension is {{ fileExtensions }} and maximum file size is up to {{ size }}.",
    "mappedAttributeDescription": "Select properties from the file to import as layer attributes (optional).",
    "layerAttribute": "Layer attribute",
    "type": "Type",
    "fieldToImport": "Field to import",
    "overwriteExisting": "Overwrite existing",
    "importLayer": "Import layer"
  },
  "importKML": {
    "invalidKML": {
      "title": "Invalid KML Data",
      "message": "The KML data is invalid, please check your source file and try again."
    },
    "folderSelectLabel": "Default import layers",
    "allFolders": "All layers"
  },
  "importGpx": {
    "invalidGpx": {
      "title": "Invalid GPX Data",
      "message": "The GPX data is invalid, please check your source file and try again."
    },
    "import_track": "Import track",
    "import_route": "Import route"
  },
  "analysis_drawing_tooltips": {
    "title": "Analysis tools",
    "enter_edit_mode": "Use the drawing tools to select map objects and analyse areas, lines etc.",
    "enter_edit_mode_link": "Click here to know more about this tool"
  },
  "dataTableGrouping": {
    "checkbox": "Group data"
  },
  "assets": {
    "edit": "Edit selected asset",
    "delete": "Delete selected asset",
    "uploadAsset": "Upload asset",
    "deleteTitleIcon": "Delete icon",
    "deleteDescriptionIcon": "Are you sure you want to delete this icon?",
    "deleteTitleModel": "Delete model",
    "deleteDescriptionModel": "Are you sure you want to delete this mode?"
  },
  "toolbarButtonTooltips": {
    "route": "Route Generator"
  },
  "routeGenerator": {
    "routeGenerator": "Route Generator",
    "distance": "Distance",
    "travelTime": "Travel time",
    "addStop": "Add stop",
    "addRoute": "New route",
    "removeStop": "Remove stop",
    "search": "Search or click on the map"
  },
  "exports": {
    "remarks": {
      "title": "Custom remarks",
      "placeholder": "Insert custom remarks here",
      "error": "Remarks is too long"
    }
  },
  "styles": {
    "modelOffset": "Model offset"
  },
  "attributes": {
    "imageDescription": "You can only upload 1 image per attribute. You can replace your selection below.",
    "imageTitle": "Upload image to attribute",
    "noImageSelected": "No file chosen"
  },
  "layerTemplates": {
    "chosenForYou": "Chosen for you"
  },
  "contextMenu": {
    "addAttributeMultipleLayers": "Add attribute to all"
  },
  "importLayers": {
    "folderOutsideMap": "Cannot import a folder from outside of a map"
  },
  "delete": {
    "multipleTitleMix": "Delete multiple items",
    "multipleDescriptionMix": "Deleting a group will delete all the layers and their objects",
    "importLayerHint": "Imported layer will be only be removed from the map and will exist in the original plan",
    "multipleLayersTitle": "Delete multiple layers",
    "multipleLayersDescription": "Deleting multiple layers will delete all of the objects in them too",
    "multipleImportLayersTitle": "Remove imported layers",
    "singleImportLayersTitle": "Remove imported layer",
    "importLayersDescription": "Deleting imported layer will only delete the objects from your map. You can import the layer from the linked map anytime",
    "singleLayerTitle": "Delete a layer",
    "singleLayerDescription": "Deleting this layer will delete all of the objects in it too"
  }
}